// frontend/modules/customer-category/stores/customer-category-store.ts
import { create } from 'zustand';
import {
    CustomerCategoryDTO,
    CustomerCategoryFieldDTO,
    CustomerCategoryProductDTO, CustomerCategoryUserGroupDTO,
    ProductDTO,
    GroupedFieldConfigurationDTO
} from "@/shared/api/model";

interface CustomerCategoryState {
    // Categories
    categories: CustomerCategoryDTO[];
    activeCategory: CustomerCategoryDTO | null;
    isLoading: boolean;
    error: string | null;

    // Products
    allProducts: ProductDTO[];
    categoryProducts: CustomerCategoryProductDTO[];

    // Fields
    groupedFieldConfiguration: GroupedFieldConfigurationDTO | null;
    categoryFields: CustomerCategoryFieldDTO[];

    // User Groups
    allUserGroups: any[]; // Will be populated from user module
    categoryUserGroups: CustomerCategoryUserGroupDTO[];

    // Form state
    formMode: 'create' | 'edit' | 'view';

    // Actions
    setCategories: (categories: CustomerCategoryDTO[]) => void;
    setActiveCategory: (category: CustomerCategoryDTO | null) => void;
    setIsLoading: (isLoading: boolean) => void;
    setError: (error: string | null) => void;

    setAllProducts: (products: ProductDTO[]) => void;
    setCategoryProducts: (products: CustomerCategoryProductDTO[]) => void;

    setGroupedFieldConfiguration: (config: GroupedFieldConfigurationDTO) => void;
    setCategoryFields: (fields: CustomerCategoryFieldDTO[]) => void;

    setAllUserGroups: (groups: any[]) => void;
    setCategoryUserGroups: (groups: CustomerCategoryUserGroupDTO[]) => void;

    setFormMode: (mode: 'create' | 'edit' | 'view') => void;
    resetState: () => void;
}

export const useCustomerCategoryStore = create<CustomerCategoryState>((set) => ({
    // Initial state
    categories: [],
    activeCategory: null,
    isLoading: false,
    error: null,

    allProducts: [],
    categoryProducts: [],

    groupedFieldConfiguration: null,
    categoryFields: [],

    allUserGroups: [],
    categoryUserGroups: [],

    formMode: 'create',

    // Actions
    setCategories: (categories) => set({ categories }),
    setActiveCategory: (activeCategory) => set({ activeCategory }),
    setIsLoading: (isLoading) => set({ isLoading }),
    setError: (error) => set({ error }),

    setAllProducts: (allProducts) => set({ allProducts }),
    setCategoryProducts: (categoryProducts) => set({ categoryProducts }),

    setGroupedFieldConfiguration: (groupedFieldConfiguration) => set({ groupedFieldConfiguration }),
    setCategoryFields: (categoryFields) => set({ categoryFields }),

    setAllUserGroups: (allUserGroups) => set({ allUserGroups }),
    setCategoryUserGroups: (categoryUserGroups) => set({ categoryUserGroups }),

    setFormMode: (formMode) => set({ formMode }),
    resetState: () => set({
        activeCategory: null,
        categoryProducts: [],
        categoryFields: [],
        categoryUserGroups: [],
        formMode: 'create'
    })
}));